import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "admin-sidebar-groups";

// Saves <details> open/closed state to localStorage on toggle.
// A synchronous inline script in the sidebar template restores state before paint.
export default class extends Controller<HTMLDetailsElement> {
  static values = { key: String };

  declare keyValue: string;

  toggle() {
    try {
      const states = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
      states[this.keyValue] = this.element.open;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(states));
    } catch {
      // Ignore storage errors
    }
  }
}
